import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import sapi from "../../../../util/sapi";
import log from "../../../../util/log";
import Image from "../../elements/Image";
import colors from "../../../../util/colors";
import utils from "../../../../util/util";
import _ from 'lodash'
import ValidationErrors from "../../components/ValidationErrors";
import {fontConstants, buildFontPicker, buildFontOption} from "../../../../util/font-constants";
import {withVFTranslation} from "../../../../util/withVFTranslation";
import SignaturePanelCanvas from "./SignaturePanelCanvas";
import Button from "../../elements/Button";
import UploadHelper, {IMAGE_FILETYPES} from "../../components/UploadHelper";
import {BiFontFamily, BiImage, BiPencil} from "react-icons/bi";
import c from "../../../../util/const";
import VFPopover from "../../components/VFPopover";
import popoverActions from "../../../../actions/popover-actions";
import popupHelper from "../../../../helpers/popup-helper";

class AccountSignaturesPanel extends Component {

  constructor(props) {
    super(props);
    
    this.signatureRef = null;
    this.signatureTextAreaRef = React.createRef();
    this.initialsRef = null;
    this.initialsTextAreaRef = React.createRef();

    this.renderUploadInfoButtonContents = this.renderUploadInfoButtonContents.bind(this);
  
    let {accountInfo} = props;
    
    let firstState = {
      sigFont : fontConstants.LA_BELLE_AURORE.familyName,
      sigFontCls : fontConstants.LA_BELLE_AURORE.class,
      initFont : fontConstants.LA_BELLE_AURORE.familyName,
      initFontCls : fontConstants.LA_BELLE_AURORE.class,
      saving : false,
      showDrawSignature : false,
      showSignatureImage : !!(props.accountSignatures && props.accountSignatures.sign_image),
      sigImageUploadedData : null,
      showDrawInitials : false,
      showInitialsImage : !!(props.accountSignatures && props.accountSignatures.init_image),
      initImageUploadedData : null,
      
      changesMade : false,
      validationErr : []
    };
    
    if(!props.accountSignatures){
      firstState.sigText = `${accountInfo.first_name} ${accountInfo.last_name}`
      firstState.initText = `${accountInfo.first_name[0]}${accountInfo.last_name[0]}`.toUpperCase()
    }
    else{
      firstState.sigText = "";
      firstState.initText = "";
    }
    
    this.state = firstState;
  }
  
  componentDidMount() {
    if(this.props.onRef){
      this.props.onRef(this);
    }
    
    if(!this.props.accountSignatures) {
      this.signatureRef.doRedrawCanvas(this.state.sigFont, this.state.sigText);
      this.initialsRef.doRedrawCanvas(this.state.initFont, this.state.initText);
      this.setState({changesMade : true})
    }
  }
  
  componentWillUnmount() {
    if(this.props.onRef){
      this.props.onRef(undefined);
    }
  }
  
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevProps.accountInfo.first_name !== this.props.accountInfo.first_name){
      if(this.signatureRef) {
        this.signatureRef.doRedrawCanvas(this.state.sigFont, this.state.sigText);
      }
      if(this.initialsRef) {
        this.initialsRef.doRedrawCanvas(this.state.initFont, this.state.initText);
      }
    }
    else if(prevProps.accountInfo.last_name !== this.props.accountInfo.last_name){
      if(this.signatureRef) {
        this.signatureRef.doRedrawCanvas(this.state.sigFont, this.state.sigText);
      }
      if(this.initialsRef) {
        this.initialsRef.doRedrawCanvas(this.state.initFont, this.state.initText);
      }
    }
    if(prevProps.accountSignatures !== this.props.accountSignatures){
      this.setState({
        showSignatureImage : !!(this.props.accountSignatures && this.props.accountSignatures.sign_image),
        showInitialsImage : !!(this.props.accountSignatures && this.props.accountSignatures.init_image),
      }, () => {
        if(this.signatureRef) {
          this.signatureRef.doRedrawCanvas(this.state.sigFont, this.state.sigText);
        }
        if(this.initialsRef) {
          this.initialsRef.doRedrawCanvas(this.state.initFont, this.state.initText);
        }
      })
    }
  }
  
  getFontOptionPicker() {
    let {t} = this.props;
    let pickerOptions = buildFontPicker([
      buildFontOption(t('Handwriting Font #1'), fontConstants.LA_BELLE_AURORE),
      buildFontOption(t('Handwriting Font #2'), fontConstants.CEDARVILLE_CURSIVE),
      buildFontOption(t('Handwriting Font #3'), fontConstants.SACRAMENTO),
      buildFontOption(t('Handwriting Font #4'), fontConstants.DANCING_SCRIPT),
    ])
    
    return pickerOptions;
  }
  
  reset() {
    let {accountInfo, accountSignatures} = this.props;
  
    let resetState = {
      sigFont : fontConstants.LA_BELLE_AURORE.familyName,
      sigFontCls : fontConstants.LA_BELLE_AURORE.class,
      initFont : fontConstants.LA_BELLE_AURORE.familyName,
      initFontCls : fontConstants.LA_BELLE_AURORE.class,
      saving : false,
      showDrawSignature : false,
      showSignatureImage : !!(accountSignatures && accountSignatures.sign_image),
      sigImageUploadedData : null,
      showInitialsImage : !!(accountSignatures && accountSignatures.init_image),
      showDrawInitials: false,
      initImageUploadedData : null,
      validationErr : []
    }
  
    if(!this.props.accountSignatures){
      resetState.sigText = `${accountInfo.first_name} ${accountInfo.last_name}`
      resetState.initText = `${accountInfo.first_name[0]}${accountInfo.last_name[0]}`.toUpperCase()
    }
    else{
      resetState.sigText = "";
      resetState.initText = "";
    }
    
    this.setState(resetState);
  
    if(this.signatureRef){
      this.signatureRef.resetCanvas()
        .then(() => {
          this.signatureRef.doRedrawCanvas(this.state.sigFont, this.state.sigText);
        })
    }
    if(this.initialsRef){
      this.initialsRef.resetCanvas()
        .then(() => {
          this.initialsRef.doRedrawCanvas(this.state.initFont, this.state.initText);
        })
    }
  }
  
  hasChanges(){
    return this.state.changesMade;
  }
  
  onSigFontChange(evt){
    let selectedValue = _.get(evt, 'target.value');
    let opt = _.find(this.getFontOptionPicker(), (opt) => opt.val === selectedValue);
    
    this.setState({
      changesMade : true,
      sigFont : selectedValue,
      sigFontCls : opt.cls,
      sigImageUploadedData : null,
      showDrawSignature : false,
      showSignatureImage : false
    }, () => {
      this.signatureRef.setDrawMode(false);
      this.signatureRef.doRedrawCanvas(this.state.sigFont, this.state.sigText);
      utils.waitForCondition(() => {
          return !!_.get(this, 'signatureTextAreaRef.current');
        })
        .then(() => {
          if(!!_.get(this, 'signatureTextAreaRef.current')) {
            this.signatureTextAreaRef.current.focus();
          }
        })
    })
  }

  onSigSetDrawMode(evt) {
    this.setState({
        changesMade: true,
        showDrawSignature: true,
        showSignatureImage: false,
        sigImageUploadedData: null
      }, () => {
        this.signatureRef.setDrawMode(true);
        this.setState({sigText: ''})
      }
    )
  }

  onSigImgClick(){
    if(this.props.preventEdit){
      return;
    }

    this.setState({
      changesMade : true,
      showSignatureImage : false,
      sigImageUploadedData : null,
      showDrawSignature : false
    }, () => {
      this.signatureRef.doRedrawCanvas(this.state.sigFont, this.state.sigText);
      utils.waitForCondition(() => {
        return !!_.get(this, 'signatureTextAreaRef.current');
      })
        .then(() => {
          if(!!_.get(this, 'signatureTextAreaRef.current')) {
            this.signatureTextAreaRef.current.focus();
          }
        })
    })
  }
  
  onInitImgClick(){
    if(this.props.preventEdit){
      return;
    }
    
    this.setState({
      changesMade : true,
      showInitialsImage : false,
      initImageUploadedData : null,
      showDrawInitials : false
    }, () => {
      this.initialsRef.doRedrawCanvas(this.state.initFont, this.state.initText);
      utils.waitForCondition(() => {
          return !!_.get(this, 'initialsTextAreaRef.current');
        })
        .then(() => {
          if(!!_.get(this, 'initialsTextAreaRef.current')) {
            this.initialsTextAreaRef.current.focus();
          }
        })
    })
  }

  onInitSetDrawMode(evt) {
    this.setState({
        changesMade: true,
        showDrawInitials: true,
        showInitialsImage: false,
        initImageUploadedData: null
      }, () => {
        this.initialsRef.setDrawMode(true);
        this.setState({initText: ''})
      }
    )
  }
  
  onInitFontChange(evt){
    let selectedValue = _.get(evt, 'target.value');
    let opt = _.find(this.getFontOptionPicker(), (opt) => opt.val === selectedValue);

    this.setState({
      changesMade : true,
      initFont : selectedValue,
      initFontCls : opt.cls,
      initImageUploadedData : null,
      showDrawInitials : false,
      showInitialsImage : false
    }, () => {
      this.initialsRef.setDrawMode(false);
      this.initialsRef.doRedrawCanvas(this.state.initFont, this.state.initText);
      utils.waitForCondition(() => {
          return !!_.get(this, 'initialsTextAreaRef.current');
        })
        .then(() => {
          if(!!_.get(this, 'initialsTextAreaRef.current')) {
            this.initialsTextAreaRef.current.focus();
          }
        })
    })
  }
  
  generateImages(){
    let { accountSignatures } = this.props;
    let {
      showInitialsImage,
      showSignatureImage,
      sigImageUploadedData,
      initImageUploadedData
    } = this.state;
  
    let sig = null;
    let init = null;
    if(initImageUploadedData){
      init = initImageUploadedData;
    }
    else if(showInitialsImage){
      init = accountSignatures.init_image;
    }
    else{
      init = this.initialsRef.generateCanvasImage();
    }

    if(sigImageUploadedData){
      sig = sigImageUploadedData;
    }
    else if(showSignatureImage){
      sig = accountSignatures.sign_image;
    }
    else{
      sig = this.signatureRef.generateCanvasImage();
    }
    
    return {
      sign_image : sig,
      init_image : init
    }
  }
  
  onSignatureTextUpdate(evt){
    this.setState({sigText : evt.target.value}, () => {
      this.signatureRef.doRedrawCanvas(this.state.sigFont, this.state.sigText);
    })
  }
  
  onInitTextUpdate(evt){
    this.setState({initText : evt.target.value}, () => {
      this.initialsRef.doRedrawCanvas(this.state.initFont, this.state.initText);
    })
  }
  
  doValidation(){
    let {
      showSignatureImage,
      showDrawInitials,
      showDrawSignature,
      showInitialsImage,
      initText,
      sigText,
    } = this.state;
    let { t } = this.props;
    
    let err = [];
    if(!showSignatureImage){
      if(showDrawSignature){
        if(!this.signatureRef.haveDrawnChangesBeenMade()){
          err.push(t("Please draw your signature"));
        }
      }
      else if(sigText.length === 0){
        err.push(t("Please enter your signature"));
      }
    }
    
    if(!showInitialsImage){
      if(showDrawInitials){
        if(!this.initialsRef.haveDrawnChangesBeenMade()){
          err.push(t("Please draw your initials"));
        }
      }
      else if(initText.length === 0){
        err.push(t("Please enter your initials"));
      }
    }
    
    this.setState({validationErr : err});
    return err.length === 0;
  }

  onSignatureFileUploadSelected(files, rejectFiles) {
    log.log('onSignatureFileUploadSelected', files, rejectFiles)
    if (files.length > 0) {
      let { t } = this.props;
      this.setState({validationErr : []})

      let imgFile = files[0];

      this.setState({
        showSignatureImage : false, //this has to be true to render canvas
      })

      utils.convertFileInputToBase64(imgFile)
        .then((res) => {
          return this.signatureRef.resizeImageWithCanvas(res);
        })
        .then((image) => {
          this.setState({
            changesMade : true,
            sigImageUploadedData : image,
            showSignatureImage : true,
          })
        })
        .catch((err) => {
          log.log('onSignatureFileUploadSelected', 'catch', err);
          this.setState({
            validationErr : [t("We were unable to process your image. Please try again.")],
            showSignatureImage : !!(this.props.accountSignatures && this.props.accountSignatures.sign_image)
          });
        })
    }
  }

  onInitialsFileUploadSelected(files, rejectFiles) {
    log.log('onInitialsFileUploadSelected', files, rejectFiles)
    if (files.length > 0) {
      let { t } = this.props;
      this.setState({validationErr : []})

      let imgFile = files[0];

      this.setState({
        showInitialsImage : false, //this has to be true to render canvas
      })

      utils.convertFileInputToBase64(imgFile)
        .then((res) => {
          return this.initialsRef.resizeImageWithCanvas(res);
        })
        .then((image) => {
          this.setState({
            changesMade : true,
            initImageUploadedData : image,
            showInitialsImage : true,
          })
        })
        .catch((err) => {
          log.log('onInitialsFileUploadSelected', 'catch', err);
          this.setState({
            validationErr : [t("We were unable to process your image. Please try again.")],
            showInitialsImage : !!(this.props.accountSignatures && this.props.accountSignatures.init_image)
          });
        })
    }
  }

  renderUploadInfoButtonContents = (logoInfoPopoverText) => (popupArgs) => {
    return popupHelper.getLogoInfoPopoverContents(
      logoInfoPopoverText,
      () => this.props.popoverAction.hidePopover()
    )
  }

  renderPanel(
    headerText,
    selectedFont,
    selectedFontOnChange,
    showImage,
    onImageClick,
    logoInfoPopoverText,
    onSetDrawMode,
    onImgUploaded,
    uploadedImgData,
    serverImgSrc,
    showDrawMode,
    onSignaturePanelCanvasRef,
    textAreaRefObj,
    textAreaFontCls,
    onTextAreaChanged,
    textAreaText,
    textAreaMaxLength
  ) {
    let {
      preventEdit,
      t
    } = this.props;

    return <>
      <div className="container-fluid">
        <div className="row">
          <div className="col px-0">
            <h5 className="align-middle mt-2">
              {headerText}
            </h5>
          </div>

          {!preventEdit &&
            <div className="col px-0">
              <div className="d-flex justify-content-end mb-1">
                <button className="btn btn-sm btn-outline-primary no-border me-1" onClick={(evt) => onImageClick(evt)}>
                  <div style={{fontSize: '24px', lineHeight: '26px'}}>
                    <BiFontFamily/>
                  </div>
                  <div className="text-uppercase mx-auto" style={{fontSize: '12px'}}>
                    {t("Type")}
                  </div>
                </button>
                <button className="btn btn-sm btn-outline-primary no-border me-1" onClick={(evt) => onSetDrawMode(evt)}>
                  <div style={{fontSize: '24px', lineHeight: '26px'}}>
                    <BiPencil/>
                  </div>
                  <div className="text-uppercase mx-auto" style={{fontSize: '12px'}}>
                    {t("Draw")}
                  </div>
                </button>
                <UploadHelper allowMultiple={true}
                              fileTypes={IMAGE_FILETYPES}
                              clickOnly={true}
                              onDrop={(evt) => onImgUploaded(evt)}>
                  <Button className="btn btn-sm btn-outline-primary no-border" type="button">
                    <div style={{fontSize: '24px', lineHeight: '26px'}}>
                      <BiImage/>
                    </div>
                    <div className="text-uppercase mx-auto" style={{fontSize: '12px'}}>
                      {t("Upload")}
                    </div>
                  </Button>
                </UploadHelper>

                <VFPopover
                  isPopoverOpen={this.props.popoverAction.isShowing(c.popovers.LOGO_INFO, headerText)}
                  positions={['bottom', 'right']}
                  reposition={false}
                  containerClassName="preview-container-cls copied-popover-container"
                  onClickOutside={() => this.props.popoverAction.hidePopover()}
                  getMenuContent={this.renderUploadInfoButtonContents(logoInfoPopoverText)}>
                  <button className="btn btn-link secondary-text-color" type="button">
                    <i style={{fontSize:'20px'}}
                       onMouseLeave={() => this.props.popoverAction.hidePopover()}
                       onMouseOver={() => this.props.popoverAction.showPopover(c.popovers.LOGO_INFO, headerText)}
                       className="icon ion-information-circled"/>
                  </button>
                </VFPopover>
              </div>
            </div>
          }
        </div>
      </div>
      <div style={styles.signatureBox} onClick={(evt) => showImage ? onImageClick(evt) : null}>
        {showImage &&
          <div style={styles.sigImgBox}>
            <div style={styles.sigImgWrap}>
              <Image style={styles.sigImg}
                     src={uploadedImgData || serverImgSrc}
                     alt={headerText}/>
            </div>
          </div>
        }
        {!showImage &&
          <>
            {!showDrawMode &&
                  <select className="form-select"
                          style={{
                            maxWidth: '13rem',
                            position: 'absolute',
                            right: '10px',
                            bottom: '10px',
                            zIndex: 101,
                            pointerEvents: 'auto'
                          }}
                        value={selectedFont}
                        onChange={(evt) => selectedFontOnChange(evt)}>
                  {this.getFontOptionPicker()
                    .map((option) => {
                      return <option className={option.cls}
                                     key={option.val}
                                     value={option.val}>
                        {option.display}
                      </option>
                    })}
                </select>
            }
            {!showDrawMode &&
              <textarea className={"m-auto text-center d-table position-absolute no-resize " + textAreaFontCls}
                        style={styles.textarea}
                        maxLength={textAreaMaxLength}
                        onChange={(evt) => onTextAreaChanged(evt)}
                        ref={textAreaRefObj}
                        value={textAreaText}/>
            }
            <SignaturePanelCanvas onRef={onSignaturePanelCanvasRef}
                                  styleObj={{zIndex: 5, pointerEvents: 'auto'}}
                                  className={showDrawMode ? "m-auto text-center d-table position-absolute" : "m-auto text-center d-table invisible position-absolute"}
                                  canvasHeight={AccountSignaturesPanel.SIG_IMG_HEIGHT}/>
          </>
        }
      </div>
    </>;
  }

  render(){
    let {
      accountSignatures,
      t
    } = this.props;
    let {
      sigFont,
      initFont,
      showSignatureImage,
      showInitialsImage,
      sigImageUploadedData,
      initImageUploadedData,
      showDrawInitials,
      showDrawSignature,
      sigText,
      sigFontCls,
      initText,
      initFontCls,
      validationErr
    } = this.state;
    
    return(
      <>
        <div className="row">
          <div className="col-6">
            {
              this.renderPanel(
                t("Signature"),
                sigFont,
                this.onSigFontChange.bind(this),
                showSignatureImage,
                this.onSigImgClick.bind(this),
                t("Images you upload may be jpeg, jpg, png, or svg. Black and white images smaller than 64k work best."),
                this.onSigSetDrawMode.bind(this),
                this.onSignatureFileUploadSelected.bind(this),
                sigImageUploadedData,
                _.get(accountSignatures, 'sign_image'),
                showDrawSignature,
                (ref) => this.signatureRef = ref,
                this.signatureTextAreaRef,
                sigFontCls,
                this.onSignatureTextUpdate.bind(this),
                sigText,
                AccountSignaturesPanel.SIG_MAX_LENGTH)
            }
          </div>
          <div className="col-6">
            {
              this.renderPanel(
                t("Initials"),
                initFont,
                this.onInitFontChange.bind(this),
                showInitialsImage,
                this.onInitImgClick.bind(this),
                t("Images you upload may be jpeg, jpg, png, or svg. Black and white images smaller than 64k work best."),
                this.onInitSetDrawMode.bind(this),
                this.onInitialsFileUploadSelected.bind(this),
                initImageUploadedData,
                _.get(accountSignatures, 'init_image'),
                showDrawInitials,
                (ref) => this.initialsRef = ref,
                this.initialsTextAreaRef,
                initFontCls,
                this.onInitTextUpdate.bind(this),
                initText,
                AccountSignaturesPanel.INIT_MAX_LENGTH)
            }
          </div>
        </div>
        {validationErr.length > 0 &&
          <div className="row">
            <div className="col mt-2">
              <ValidationErrors errors={validationErr}/>
            </div>
          </div>
        }
      </>
    )
  }
}

AccountSignaturesPanel.MAX_TEXTAREA_HEIGHT = 167;
AccountSignaturesPanel.SIG_MAX_LENGTH = 40;
AccountSignaturesPanel.INIT_MAX_LENGTH = 5;
AccountSignaturesPanel.SIG_IMG_HEIGHT = 48;

const styles = {
  signatureBox : {
    border : `1px solid ${colors.LIGHT_GREY}`,
    borderRadius : '5px',
    textAlign : 'center',
    minHeight : (AccountSignaturesPanel.MAX_TEXTAREA_HEIGHT + 2) + 'px', // the +2 is for top and bottom 1px border.
    position : 'relative',
  },
  textarea : {
    border: 'none',
    borderRadius : '5px',
    fontSize : '32px',
    lineHeight : '124px',
    padding: '16px',
    zIndex: 6,
    width: "100%",
    maxHeight: '100%',
    wordBreak: 'keep-all',
    whiteSpace: 'nowrap',
    minHeight : AccountSignaturesPanel.MAX_TEXTAREA_HEIGHT + 'px',
    height : AccountSignaturesPanel.MAX_TEXTAREA_HEIGHT + 'px',
    outline: 0,
    overflow:'hidden'
  },
  sigImgBox : {
    maxHeight: AccountSignaturesPanel.MAX_TEXTAREA_HEIGHT + 'px',
    height: AccountSignaturesPanel.MAX_TEXTAREA_HEIGHT + 'px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  sigImgWrap : {
    lineHeight: AccountSignaturesPanel.MAX_TEXTAREA_HEIGHT - 2 + 'px', //minus 2 for the border.
    height: '100%',
    //margin: 'auto',
    textAlign: 'center'
  },
  sigImg : {
    display: 'inline',
    verticalAlign : 'middle',
    height: 'auto',
    margin: 'auto',
  }
}

AccountSignaturesPanel.propTypes = {
  onRef : PropTypes.func.isRequired,
  preventEdit : PropTypes.bool
}

const mapStateToProps = (state) => {
  return {
    accountSignatures : state.shared.signatures,
    accountInfo : state.shared.accountInfo,
    showingPopoverKey : state.popover.showingPopoverKey
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    popoverAction : {...popoverActions.mapToDispatch(dispatch)},
  };
};

export default withVFTranslation()(connect(mapStateToProps, mapDispatchToProps)(AccountSignaturesPanel));
